import React from "react";
import { CheckCircle2 } from "lucide-react";

const StaffTasksEmpty = ({ viewFilter }) => (
    <div className="rounded-xl border border-dashed border-success/30 bg-success/5 p-8 text-center">
        <div className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-success/15">
            <CheckCircle2 size={28} className="text-success" />
        </div>
        <h3 className="text-base font-semibold text-ink">
            {viewFilter === "today"
                ? "You're all caught up for today"
                : "No tasks assigned"}
        </h3>
        <p className="text-sm text-ink-muted mt-1 max-w-xs mx-auto">
            {viewFilter === "today"
                ? "Nothing due today. Check all tasks or add one below."
                : "When your manager assigns work, it will show up here."}
        </p>
    </div>
);

export default StaffTasksEmpty;
